module.exports = __webpack_public_path__ + "img/40-white.5199ebb8.svg";